// components/HorizontalTimeline.tsx
import CtaButtonGroup, { CtaType } from '@/components/molecules/CtaButtonGroup';
import React from 'react';

interface TimelineItem {
  period: string;
  title: string;
  description: string;
  color: 'green' | 'yellow' | 'blue';
  isAbove?: boolean;
}
interface RoadmapItem {
    discountInfo:string;
    ctas:CtaType[],
    roadmapData:TimelineItem[],
    title:string,
    subTitle:string
}

const TimelineItem: React.FC<TimelineItem> = ({ period, title, description, color, isAbove }) => {
  const colorClasses = {
    green: 'bg-green-0 border-green-2',
    yellow: 'bg-yellow-0 border-yellow-4',
    blue: 'bg-purple-0 border-purple-3',
  };

  const dotColorClasses = {
    green: 'bg-green-2 border-green-0 ',
    yellow: 'bg-yellow-4 border-yellow-0 ',
    blue: 'bg-purple-3 border-purple-0 ',
  };

  return (
    <div className={`flex flex-col items-center w-[210px] mx-4 relative `}>
      <div className={`${colorClasses[color]} rounded-lg p-3 shadow-md border h-[180px] relative border-l-0`}>
        <div className="text-xs font-bold mb-2">{period}</div>
        <h3 className="text-md font-semibold mb-2">{title}</h3>
        <p className="text-sm">{description}</p>
        <div className={`absolute left-0 w-0.5 ${dotColorClasses[color]} ${!isAbove ? 'bottom-0 h-[calc(100%+3.25rem)]' : 'top-0 h-[calc(100%+3.25rem)]'}`}></div>
      </div>
      {/* <div className={`absolute ${isAbove ? '-bottom-16' : '-top-16'} left-0 w-10 h-10 rounded-full ${dotOuterColorClasses[color]} `}></div> */}
      <div className={`absolute ${isAbove ? '-bottom-16' : '-top-16'} left-0 w-4 h-4 rounded-full ${dotColorClasses[color]}  box-content border-8 `}></div>
      
    </div>
  );
};

const Roadmap: React.FC<RoadmapItem> = ({title,subTitle,ctas,roadmapData}) => {
//   const items: TimelineItem[] = [
//     {
//       period: '1-2 MONTHS',
//       title: 'Launch your course',
//       description: 'Transform your idea into a live course, ready to engage learners and start generating interest.',
//       color: 'green',
//     },
//     {
//       period: '2-3 MONTHS',
//       title: 'Attract ideal audience',
//       description: 'Build a targeted audience eager to enroll, ensuring a steady stream of potential students.',
//       color: 'blue',
//     },
//     {
//       period: '3-6 MONTHS',
//       title: 'Generate revenue',
//       description: 'Begin earning from your course, creating a reliable income stream and seeing financial growth.',
//       color: 'yellow',
//     },
//     {
//       period: '6-12 MONTHS',
//       title: 'Build Your Brand',
//       description: 'Establish yourself as an authority in your field, enhancing your reputation and unlocking new opportunities.',
//       color: 'green',
//     },
//     {
//       period: '12-18 MONTHS',
//       title: 'Optimize & scale',
//       description: 'Refine and expand your course offerings, reaching a larger audience and maximizing your impact.',
//       color: 'blue',
//     },
//     {
//       period: 'ONGOING',
//       title: 'Enjoy flexibility',
//       description: 'Gain more control over your schedule and enjoy a fulfilling career aligned with your passions.',
//       color: 'yellow',
//     },
//     {
//       period: 'ONGOING',
//       title: 'Get continued support',
//       description: 'Benefit from continuous resources and expert guidance, ensuring sustained growth and success.',
//       color: 'green',
//     },
//   ];

  return (
    <div className="bg-grey-1 py-10">
      <h2 className="text-2xl font-bold text-center mb-20">
        {title}
      </h2>
      <div className="relative overflow-hidden">
        {/* Timeline line start */}
        <div className="absolute top-1/2 h-2 bg-purple-1 transform -translate-y-1/2 w-screen left-1/2 -translate-x-1/2"></div> 
        <div className="flex mx-auto max-w-6xl px-4 h-[450px]">
       
          {roadmapData.map((item, index) => (
            
             <div key={index} className={`flex justify-center ${index % 2 === 0 ? 'items-start' : 'items-end'} ${index > 0 ? '-ml-24' : ''}`}>
            <TimelineItem key={index} {...item} isAbove={index % 2 === 0} />
            </div>
          ))}
          
        </div>
      </div>
      <div className="text-center mt-12">
        <p className="mb-4">{subTitle}</p>
        
              <CtaButtonGroup align="sm:center" ctas={ctas} affiliateButton={true}  />
             
           
      </div>
    </div>
  );
};

export default Roadmap;